import React, {useEffect, useRef} from 'react';
import styled from '@emotion/styled'

const ButtonShowRefWrapper = styled.button`
    align-items: center;
    gap: 10px;
    img{
        &.rotate{
            transform: rotate(180deg);
        }
    }
`

const ButtonShowRef = ({children, arrTargetRef, isShow})=>{

    const savedArrTargetRef = useRef(arrTargetRef);

    const iconRef = useRef(null)

    useEffect(() => {
      if (savedArrTargetRef.current && !savedArrTargetRef.current.every(element => !element)) {
            savedArrTargetRef.current.forEach(elementRef => {
            elementRef.current.classList.add('off');
            if (isShow) {
                elementRef.current.classList.remove("off");
                iconRef.current.classList.add("rotate");
            }
        });
      }
    }, [isShow]);

    return (
        <ButtonShowRefWrapper onClick={
            ()=>{
                if(
                    arrTargetRef && !arrTargetRef.every(element=>!element) && iconRef
                ) {
                    arrTargetRef.forEach(
                        (elementRef)=>{
                            if(elementRef.current.classList.contains("off")){
                                elementRef.current.classList.remove("off");
                                iconRef.current.classList.add("rotate");
                            } else {
                                elementRef.current.classList.add("off");
                                iconRef.current.classList.remove("rotate");
                            }
                        }
                    )
                }
            }
        }
        
        >
            <img src="/image/icon/icon_triangle_stroke_gray.svg"
                className={isShow?"rotate":""}
                alt="" 
                ref={iconRef}
            />
            {children}
            <p className="hidden">
                내용 보이기 또는 숨기기
            </p>
        </ButtonShowRefWrapper>
    )
}

export default ButtonShowRef;